(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['use-swipe-hook'] = {}, global.React));
}(this, (function (exports, react) { 'use strict';

  var useSwipePosition = function (_a) {
      var ref = _a.ref, _b = _a.useRelativeUnits, useRelativeUnits = _b === void 0 ? false : _b;
      var _c = react.useState(0), x1 = _c[0], setX1 = _c[1];
      var _d = react.useState(0), y1 = _d[0], setY1 = _d[1];
      var _e = react.useState(0), x2 = _e[0], setX2 = _e[1];
      var _f = react.useState(0), y2 = _f[0], setY2 = _f[1];
      react.useEffect(function () {
          var currentElement = ref.current;
          if (currentElement) {
              if (isTouchDevice()) {
                  currentElement.addEventListener('touchstart', handleTouchStart);
                  currentElement.addEventListener('touchend', handleTouchEnd);
              }
              else {
                  currentElement.addEventListener('mousedown', handleMouseDown);
                  currentElement.addEventListener('mouseup', handleMouseUp);
              }
          }
          return function () {
              if (currentElement) {
                  if (isTouchDevice()) {
                      currentElement.removeEventListener('touchstart', handleTouchStart);
                      currentElement.removeEventListener('touchend', handleTouchEnd);
                  }
                  else {
                      currentElement.removeEventListener('mousedown', handleMouseDown);
                      currentElement.removeEventListener('mouseup', handleMouseUp);
                  }
              }
          };
      }, [ref]);
      function handleTouchStart(event) {
          setX1(event.changedTouches[0].clientX);
          setY1(event.changedTouches[0].clientY);
      }
      function handleTouchEnd(event) {
          if (event.changedTouches && event.changedTouches.length > 0) {
              setX2(event.changedTouches[0].clientX);
              setY2(event.changedTouches[0].clientY);
          }
      }
      function handleMouseDown(event) {
          var _a = getDimensionsFromEvent(event), x = _a.x, y = _a.y;
          setX1(x);
          setY1(y);
      }
      function handleMouseUp(event) {
          var _a = getDimensionsFromEvent(event), x = _a.x, y = _a.y;
          setX2(x);
          setY2(y);
      }
      function getDimensionsFromEvent(event) {
          var x = event.clientX, y = event.clientY;
          if (useRelativeUnits && ref.current) {
              var _a = ref.current.getBoundingClientRect(), top_1 = _a.top, left = _a.left;
              x -= left;
              y -= top_1;
          }
          return { x: x, y: y };
      }
      return { x1: x1, y1: y1, x2: x2, y2: y2 };
  };
  var isTouchDevice = function () { return 'ontouchstart' in window; };

  exports.SWIPE_DIRECTION = void 0;
  (function (SWIPE_DIRECTION) {
      SWIPE_DIRECTION["RIGHT"] = "right";
      SWIPE_DIRECTION["LEFT"] = "left";
      SWIPE_DIRECTION["UP"] = "up";
      SWIPE_DIRECTION["DOWN"] = "down";
  })(exports.SWIPE_DIRECTION || (exports.SWIPE_DIRECTION = {}));
  var useSwipe = function (_a) {
      var ref = _a.ref, _b = _a.thresholdPX, thresholdPX = _b === void 0 ? 5 : _b;
      var _c = useSwipePosition({ ref: ref }), x1 = _c.x1, y1 = _c.y1, x2 = _c.x2, y2 = _c.y2;
      var _d = react.useState(null), direction = _d[0], setDirection = _d[1];
      react.useEffect(function () {
          if (Math.abs(x2 - x1) > Math.abs(y2 - y1) && Math.abs(x2 - x1) > thresholdPX) {
              setDirection(x2 > x1 ? exports.SWIPE_DIRECTION.RIGHT : exports.SWIPE_DIRECTION.LEFT);
          }
          else if (Math.abs(y2 - y1) > thresholdPX) {
              setDirection(y2 > y1 ? exports.SWIPE_DIRECTION.DOWN : exports.SWIPE_DIRECTION.UP);
          }
      }, [y2]);
      return direction;
  };

  function square(x) {
      return x * x;
  }
  function radToDeg(x) {
      return (x * 180) / Math.PI;
  }

  var useSwipeVector = function (_a) {
      var ref = _a.ref, _b = _a.thresholdPX, thresholdPX = _b === void 0 ? 5 : _b, _c = _a.unit, unit = _c === void 0 ? 'rad' : _c, _d = _a.useRelativeUnits, useRelativeUnits = _d === void 0 ? false : _d;
      var _e = useSwipePosition({ ref: ref, useRelativeUnits: useRelativeUnits }), x1 = _e.x1, y1 = _e.y1, x2 = _e.x2, y2 = _e.y2;
      var _f = react.useState(0), direction = _f[0], setDirection = _f[1];
      var _g = react.useState(0), magnitude = _g[0], setMagnitude = _g[1];
      react.useEffect(function () {
          var mag = Math.sqrt(square(x2 - x1) + square(y2 - y1));
          if (mag > thresholdPX) {
              var angleRad = (2 * Math.PI + Math.atan2(y2 - y1, x2 - x1)) % (2 * Math.PI);
              setMagnitude(mag);
              setDirection(unit === 'rad' ? angleRad : radToDeg(angleRad));
          }
      }, [y2]);
      return { direction: direction, magnitude: magnitude, origin: { x: x1, y: y1 } };
  };

  exports.useSwipe = useSwipe;
  exports.useSwipePosition = useSwipePosition;
  exports.useSwipeVector = useSwipeVector;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.js.map
